const STORAGE_KEY = 'dca-admin-theme';
const LIGHT_CLASS = 'admin-theme-light';

const ADMIN_PATHS = new Set([
  '/login',
  '/dashboard',
  '/welcome',
  '/auth-management',
  '/bug-management',
  '/user-login-info',
  '/interested-users',
]);

export const isAdminPath = (path) => ADMIN_PATHS.has(path);

export const getAdminTheme = () => {
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved === 'dark' ? 'dark' : 'light';
};

export const applyAdminTheme = (theme = getAdminTheme()) => {
  const root = document.documentElement;
  if (theme === 'light') {
    root.classList.add(LIGHT_CLASS);
  } else {
    root.classList.remove(LIGHT_CLASS);
  }
};

export const clearAdminTheme = () => {
  document.documentElement.classList.remove(LIGHT_CLASS);
};

export const toggleAdminTheme = () => {
  const next = getAdminTheme() === 'light' ? 'dark' : 'light';
  localStorage.setItem(STORAGE_KEY, next);
  applyAdminTheme(next);
  return next;
};

export const syncThemeForRoute = (path) => {
  if (isAdminPath(path)) {
    applyAdminTheme();
  } else {
    clearAdminTheme();
  }
};
